export function pinValidator(pin) {
  if (pin.length !== 6) return "The pin must be 6 digits";
  return "";
}
